export const url_memed = 'https://api.memed.com.br/v1';

const local = 'http://127.0.0.1:3322/api';
const api = 'https://apicareyes.medyes.com.br/api';
const api_homolog = 'https://apitesteyes.medyes.com.br/api';

export const urls = {
  'development': local,
  'production': api,
  'homologation': api_homolog
}

export const hostname_env = {
  'careyes.medyes.com.br': 'production',
  'careyes-teste.medyes.com.br': 'homologation',
  'localhost':'development'
}


export const NODE_ENV = 'production'; // development, production or homologation
